<div class="tab-header">
    <h4>Edit Documentation: {{_collection.date | date: 'MM/yyyy'}} ({{_collection.title}})</h4>
</div>
<div class="button-area">
    <button class="btn btn-link" type="button" tabindex="0" [routerLink]="['..']"><i class="icon-arrow-left-circle"></i>
        Back
    </button>
</div>
<div class="upload-gallery">
    <div class="upload-file mb-6">
        <div class="uploadfilecontainer" (click)="fileInput.click()" appDragDrop (files)="filesSelected($event)">
            <input hidden type="file" multiple #fileInput (change)="filesSelected($event.target.files)" accept="image/*">
        </div>
    </div>

    <div class="gallery" [class.thumbnail]="photo | isCollectionThumbnail: _collection" *ngFor="let photo of photos">
        <div class="gallery-img">
            <img [src]="photo.thumbnailUrl" alt="..." class="img-responsive">
        </div>
        <div class="gallery-info">

            <button type="button"
                    class="btn"
                    *ngIf="!(photo | isCollectionThumbnail: _collection)"
                    (click)="setThumbnail(photo)"><i class="icon-location-pin"></i>
            </button>
            <button type="button" class="btn" (click)="showFullscreen(photo)"><i class="icon-size-fullscreen"></i>
            </button>
            <button type="button" class="btn" (click)="showEdit(photo)"><i class="icon-note"></i></button>
            <button *ngIf="currentUser?.permissions.canManagePlantingSites" type="button" class="btn btn-delete" (click)="deletePhoto(photo)" title="Delete">
                <i class="icon-trash"></i></button>
        </div>
    </div>
</div>


<!-- Modal confirm delete -->
<app-confirm-delete-modal-component></app-confirm-delete-modal-component>

<!-- Modal Map -->
<div bsModal #editModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-body" *ngIf="editPhoto">
                <app-photo-editor [defaultMapLocation]="site | latLonToPoint"
                                  [canSetThumbnail]="true"
                                  [showValidation]="showEditValidation"
                                  (setAsThumbnail)="setThumbnail($event)"
                                  [photo]="editPhoto"></app-photo-editor>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" aria-label="Close" (click)="saveEdit()">Update
                </button>
                <button type="button"
                        class="btn btn-outline-dark"
                        data-dismiss="modal"
                        aria-label="Close"
                        (click)="closeEditModal()">Cancel
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Modal Full screen -->
<div bsModal #fullModal="bs-modal" class="modal fade modal-full-screen-img" tabindex="-1" role="dialog" aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="close pull-right" aria-label="Close" (click)="fullModal.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
                <img *ngIf="fullscreenPhoto" [src]="fullscreenPhoto.originalUrl"/>

            </div>
        </div>
    </div>
</div>

<!-- Modal Wizard -->
<div bsModal
     #wizardModal="bs-modal"
     class="modal fade"
     tabindex="-1"
     role="dialog"
     aria-labelledby="dialog-sizes-name1"
     [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-xl modal-wizard">
        <app-upload-wizard class="modal-content"
                           *ngIf="files"
                           [defaultMapLocation]="site | latLonToPoint"
                           [collectionId]="_collection.id"
                           [files]="files"
                           (photoUploaded)="photoChanged($event)"
                           (close)="closeWizard()"></app-upload-wizard>

    </div>
</div>
